/**
 * Access Token のメモリストア。
 *
 * - リロードで揮発するのが正しい挙動 (refresh Cookie から silent refresh で再取得)
 * - subscriber を介して useAuth が再レンダーを引き起こせるようにする
 */
type Listener = (token: string | null) => void;

class TokenStore {
  private token: string | null = null;
  private listeners = new Set<Listener>();

  get(): string | null {
    return this.token;
  }

  set(token: string | null): void {
    this.token = token;
    for (const l of this.listeners) l(token);
  }

  subscribe(l: Listener): () => void {
    this.listeners.add(l);
    return () => this.listeners.delete(l);
  }
}

export const tokenStore = new TokenStore();
